import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../apiconfig";

function UploadPDF() {

    const [pdfName, setPdfName] = useState("");
    const [pdfFile, setPdfFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pdfList, setPdfList] = useState([]);

    useEffect(() => {

        fetchPDFList();

    }, []);

    const showAlert = (message) => {

        alert(message);
    };

    const fetchPDFList = async () => {

        try {

            const token = sessionStorage.getItem("adminToken");

            const response = await fetch(
                `${API_BASE_URL}/API/Student/GET_NOTICES`,
                {
                    method: "GET",
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                }
            );

            const data = await response.json();

            if (response.ok) {

                setPdfList(data);
            }

        } catch (error) {

            console.error(error);
        }
    };

    const handleFileChange = (e) => {

        const file = e.target.files[0];

        if (!file) {
            return;
        }

        if (file.type !== "application/pdf") {

            showAlert("Please select PDF file only ❌");

            return;
        }

        setPdfFile(file);
    };

    const handleUpload = async () => {

        try {

            if (!pdfName.trim()) {

                showAlert("Please enter PDF name ❌");

                return;
            }

            if (!pdfFile) {

                showAlert("Please select PDF file ❌");

                return;
            }

            setLoading(true);

            const token = sessionStorage.getItem("adminToken");

            const formData = new FormData();

            formData.append("pdfName", pdfName);
            formData.append("file", pdfFile);

            const response = await fetch(
                `${API_BASE_URL}/API/Admin/UPLOAD_PDF`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": "Bearer " + token
                    },
                    body: formData
                }
            );

            const data = await response.text();

            if (response.ok) {

                showAlert("PDF Uploaded Successfully ✅");

                setPdfName("");

                setPdfFile(null);

                document.getElementById("pdfInput").value = "";

                fetchPDFList();

            } else {

                showAlert(data || "Upload Failed ❌");
            }

        } catch (error) {

            console.error(error);

            showAlert("Server Error ❌");

        } finally {

            setLoading(false);
        }
    };

    const handleDelete = async (fileName) => {

        try {

            const token = sessionStorage.getItem("adminToken");

            const response = await fetch(
                `${API_BASE_URL}/API/Admin/DELETE_PDF/${fileName}`,
                {
                    method: "DELETE",
                    headers: {
                        "Authorization": "Bearer " + token
                    }
                }
            );

            if (response.ok) {

                showAlert("PDF Deleted Successfully ✅");

                fetchPDFList();

            } else {

                showAlert("Delete Failed ❌");
            }

        } catch (error) {

            console.error(error);

            showAlert("Server Error ❌");
        }
    };

    return (
        <>
            <style>
                {`
                    .upload-wrapper{
                        max-width:900px;
                        margin:auto;

                        background:#ffffff;

                        padding:30px;

                        border-radius:18px;

                        box-shadow:0 4px 18px rgba(0,0,0,0.08);

                        border:1px solid #e2e8f0;
                    }

                    .upload-title{
                        font-size:26px;
                        font-weight:700;

                        color:#1e3a8a;

                        margin-bottom:25px;

                        text-align:center;
                    }

                    .form-group{
                        display:flex;
                        flex-direction:column;

                        margin-bottom:20px;
                    }

                    .form-group label{
                        font-size:14px;
                        font-weight:600;

                        color:#334155;

                        margin-bottom:8px;
                    }

                    .form-group input{
                        padding:13px;

                        border-radius:12px;

                        border:1px solid #cbd5e1;

                        font-size:15px;

                        outline:none;
                    }

                    .upload-btn{
                        width:100%;

                        border:none;
                        outline:none;

                        padding:14px;

                        border-radius:14px;

                        background:linear-gradient(135deg,#2563eb,#1d4ed8);

                        color:white;

                        font-size:16px;
                        font-weight:600;

                        cursor:pointer;
                    }

                    .upload-btn:disabled{
                        opacity:0.7;
                    }

                    .pdf-table{
                        width:100%;

                        border-collapse:collapse;

                        margin-top:25px;
                    }

                    .pdf-table th{
                        background:#2563eb;

                        color:white;

                        padding:14px;
                    }

                    .pdf-table td{
                        padding:14px;

                        border-bottom:1px solid #e2e8f0;
                    }

                    .action-btn{
                        border:none;

                        padding:8px 14px;

                        border-radius:8px;

                        color:white;

                        cursor:pointer;

                        margin-right:8px;
                    }

                    .view-btn{
                        background:#16a34a;
                    }

                    .delete-btn{
                        background:#dc2626;
                    }

                    @media(max-width:768px){

                        .upload-wrapper{
                            padding:20px;
                        }

                        .upload-title{
                            font-size:22px;
                        }
                    }
                `}
            </style>

            <div className="upload-wrapper">

                <div className="upload-title">
                    Upload PDF To S3
                </div>

                <div className="form-group">

                    <label>PDF Name</label>

                    <input
                        type="text"
                        placeholder="Enter PDF Name"
                        value={pdfName}
                        onChange={(e) => setPdfName(e.target.value)}
                    />

                </div>

                <div className="form-group">

                    <label>Select PDF</label>

                    <input
                        id="pdfInput"
                        type="file"
                        accept="application/pdf"
                        onChange={handleFileChange}
                    />

                </div>

                <button
                    className="upload-btn"
                    onClick={handleUpload}
                    disabled={loading}
                >
                    {
                        loading
                        ? "Uploading..."
                        : "Upload PDF"
                    }
                </button>

                <table className="pdf-table">

                    <thead>

                        <tr>

                            <th>PDF Name</th>

                            <th>Actions</th>

                        </tr>

                    </thead>

                    <tbody>

                        {
                            pdfList.length > 0 ? (

                                pdfList.map((pdf, index) => (

                                    <tr key={index}>

                                        <td>
                                            {pdf.title}
                                        </td>

                                        <td>

                                            <button
                                                className="action-btn view-btn"
                                                onClick={() => {

                                                    const pdfWindow = window.open("");

                                                    pdfWindow.document.write(
                                                        `<iframe width='100%' height='100%' src='data:application/pdf;base64,${pdf.file}'></iframe>`
                                                    );
                                                }}
                                            >
                                                View PDF
                                            </button>

                                            <button
                                                className="action-btn delete-btn"
                                                onClick={() => handleDelete(pdf.title)}
                                            >
                                                Delete
                                            </button>

                                        </td>

                                    </tr>
                                ))

                            ) : (

                                <tr>

                                    <td
                                        colSpan="2"
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        No PDF Found
                                    </td>

                                </tr>
                            )
                        }

                    </tbody>

                </table>

            </div>
        </>
    );
}

export default UploadPDF;